var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultancy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5648 2.39091C12.7111 3.58821 13.4154 5.21219 13.4154 7.00065C13.4154 10.6825 10.4306 13.6673 6.7487 13.6673C3.0668 13.6673 0.0820312 10.6825 0.0820312 7.00065C0.0820312 3.31875 3.0668 0.333984 6.7487 0.333984C8.56088 0.333984 10.2042 1.05704 11.4059 2.23039C11.4597 2.283 11.5127 2.33652 11.5648 2.39091ZM12.082 7.00065C12.082 9.94617 9.69422 12.334 6.7487 12.334C3.80318 12.334 1.41536 9.94617 1.41536 7.00065C1.41536 4.1671 3.62509 1.84966 6.4153 1.67757C6.59905 1.66624 6.7487 1.81656 6.7487 2.00065V6.4233C6.7487 6.6799 7.02648 6.84028 7.2487 6.71198L11.0799 4.50005C11.2392 4.40806 11.4439 4.46213 11.5259 4.62682C11.8819 5.34173 12.082 6.14781 12.082 7.00065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.df8139dd50cfafd5a62b17cf76cec3ef.svg";
export { ForwardRef as ReactComponent };